import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import configData from "../../config/config.json";
import { lookupAlert } from "../../redux/actions/alertActions.js";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";
import Loading from "../common/modal/Loading";
import { chevronRightIconBlue, envelopeIconBlack, mobileIcon } from "../../img/font_awesome/font_awesome";

export default function AlertListSmall() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [alerts, setAlerts] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState("");

  useEffect(() => {
    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alerts", { filterText: "", statusType: "ALL", emailAddressId: "", phoneNumberId: "" }, { withCredentials: true })
      .then((response) => {
        setAlerts(response.data.content.alerts || []);
      })
      .catch((error) => {
        handleError(error, history);
      });
  }, [history]);

  const handleNewAlertEntry = () => {
    dispatch({ type: "RESET_SELECTED_ALERT" });
    history.push("/alertEntryMobile");
  };

  const handleEditRow = (id) => {
    setLoadingStatus(LOADING_STATUES.LOADING);
    dispatch(lookupAlert(id, () => {
      setLoadingStatus("");
      history.push("/alertEntryMobile");
    }));
  };

  return (
    <>
      <div style={styles.container}>
        <div style={styles.header}>
          <span>My Alerts</span>
          <button style={styles.addButton} onClick={handleNewAlertEntry}>
            Add New Alert
          </button>
        </div>

        <div style={styles.content}>
          {alerts.length === 0 ? (
            <div style={styles.empty}>Tap "Add New Alert" to create your very first alert.</div>
          ) : (
            alerts.map((alertResult, index) => (
              <div
                key={index}
                style={{
                  ...styles.alertRow,
                  borderBottom: index === alerts.length - 1 ? "none" : styles.alertRow.borderBottom,
                }}
                onClick={() => handleEditRow(alertResult.id)}
              >
                <div style={styles.alertRowInner}>
                  <div style={styles.alertRowContent}>
                    <div style={styles.alertName}>{alertResult.name}</div>

                    <div style={styles.alertMeta}>
                      <span style={styles.metaLabel}>Criteria:</span> {alertResult.criteria} ({alertResult.criteriaType})
                    </div>

                    {alertResult.emailAddressDTOs && alertResult.emailAddressDTOs.length > 0 && (
                      <div style={styles.alertMeta}>
                        <span style={styles.metaIcon}>{envelopeIconBlack}</span>
                        {alertResult.emailAddressDTOs.map((emailAddressDTO, emailIndex) => (
                          <span key={emailIndex} style={styles.metaValue}>
                            {emailAddressDTO.verified === true
                              ? emailAddressDTO.emailAddress
                              : <s>{emailAddressDTO.emailAddress}</s>}
                            {emailIndex < alertResult.emailAddressDTOs.length - 1 ? ", " : ""}
                          </span>
                        ))}
                      </div>
                    )}

                    {alertResult.phoneDTOs && alertResult.phoneDTOs.length > 0 && (
                      <div style={styles.alertMeta}>
                        <span style={styles.metaIcon}>{mobileIcon}</span>
                        {alertResult.phoneDTOs.map((phoneDTO, phoneIndex) => (
                          <span key={phoneIndex} style={styles.metaValue}>
                            {phoneDTO.verified === true && phoneDTO.validated === true
                              ? phoneDTO.phoneNumber
                              : <s>{phoneDTO.phoneNumber}</s>}
                            {phoneIndex < alertResult.phoneDTOs.length - 1 ? ", " : ""}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  <span style={styles.chevron}>{chevronRightIconBlue}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Loading loadingIndicator={loadingStatus === LOADING_STATUES.LOADING} />
    </>
  );
}

// Styles
const styles = {

  container: {
    marginTop: "16px",
    border: "2px solid #114E6B",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(17, 78, 107, 0.12)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    backgroundColor: "#114E6B",
    fontWeight: "bold",
    color: "white",
  },

  content: {
    padding: "4px 12px",
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "1.5",
    maxHeight: "360px",
    overflowY: "auto",
  },

  alertRow: {
    padding: "10px 0",
    borderBottom: "2px solid #adb5bd",
    cursor: "pointer",
  },

  alertRowInner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  alertRowContent: {
    flex: 1,
  },

  alertName: {
    fontWeight: "bold",
    color: "#114E6B",
    fontSize: "15px",
  },

  chevron: {
    fontSize: "14px",
    marginLeft: "8px",
  },

  alertMeta: {
    marginTop: "4px",
    color: "#444",
    fontSize: "13px",
  },

  metaLabel: {
    fontWeight: "bold",
  },

  metaIcon: {
    marginRight: "6px",
  },

  metaValue: {
    marginRight: "2px",
  },

  addButton: {
    backgroundColor: "white",
    color: "#114E6B",
    border: "none",
    padding: "4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "12px",
    whiteSpace: "nowrap",
  },

  empty: {
    color: "#444",
    fontWeight: "bold",
  },

};
